import Vue from 'vue';
import { student, activity, application, keyboard, mapState, mapGetters } from '../store/helpers';
import { KeyboardingActivityCategory } from '../graph/types/schema-generated-types';
const productCurriculumIdMap = {
    1: 'KWT - Kindergarten',
    2: 'KWT - Grade 1',
    3: 'KWT - Grade 2',
    4: 'KWT - Grade 3',
    5: 'KWT - Grade 4',
    6: 'KWT - Grade 5'
};
export default Vue.extend({
    computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mapState(student, {
        curriculumPosition: state => state.position.next
    })), mapState(application, ['theme', 'kwtMode', 'modal'])), mapState(activity, ['data', 'dataLoaded', 'showIntro', 'viewedIntro'])), mapState(student, ['licenses', 'grade'])), mapState(activity, {
        shouldShowIntro: ({ viewedIntro, showIntro }) => !viewedIntro && showIntro,
        isSpotCheck: state => Boolean(state.data.spotCheck)
    })), mapGetters(activity, ['activityTitle', 'showAssessmentAcceleratorIntro', 'isEndOfActivity'])), mapState(keyboard, ['show'])),
    methods: Object.assign(Object.assign({}, mapGetters(activity, ['isAssessmentAcceleratorActivity'])), { setAppTitle(titleDescription = '') {
            const title = this.getAppTitle(titleDescription);
            if (!title)
                return;
            document.title = title;
        },
        translateCategory() {
            var _a;
            const category = (_a = this.data) === null || _a === void 0 ? void 0 : _a.category;
            switch (category) {
                case KeyboardingActivityCategory.ASSESSMENT_ACCELERATOR_ELA: {
                    return 'ELA - Assessment Accelerator';
                }
                case KeyboardingActivityCategory.ASSESSMENT_ACCELERATOR_MATH: {
                    return 'Math - Assessment Accelerator';
                }
                case KeyboardingActivityCategory.ASSESSMENT_ACCELERATOR_STEM: {
                    return 'STEM - Assessment Accelerator';
                }
            }
        },
        isKeyboardCheckActivity() {
            var _a;
            return (((_a = this.data) === null || _a === void 0 ? void 0 : _a.scheduledActivityId) &&
                !this.isSpotCheck &&
                !this.isAssessmentAcceleratorActivity());
        },
        formatAADescription() {
            var _a;
            const description = (_a = this.data) === null || _a === void 0 ? void 0 : _a.description;
            const [grade, module, question] = description === null || description === void 0 ? void 0 : description.split(',');
            if (this.isAAIntro())
                return module === null || module === void 0 ? void 0 : module.trim();
            return `${module === null || module === void 0 ? void 0 : module.trim()} - ${question === null || question === void 0 ? void 0 : question.trim()}`;
        },
        getActivityTitle(isTeacherCreation = false) {
            var _a;
            const activityName = isTeacherCreation ? this.data.title : (_a = this.activityTitle) === null || _a === void 0 ? void 0 : _a.display;
            if (this.isAAIntro())
                return `Introduction Page`;
            if (this.shouldShowIntro)
                return `${activityName} Activity Introduction Page`;
            return `${activityName} Activity`;
        },
        weekText() {
            var _a;
            return `Week ${(_a = this.curriculumPosition) === null || _a === void 0 ? void 0 : _a.week}`;
        },
        activityAsnText() {
            var _a;
            return `Activity ${(_a = this.curriculumPosition) === null || _a === void 0 ? void 0 : _a.asn}`;
        },
        isAAIntro() {
            return (this.isAssessmentAcceleratorActivity() &&
                this.showAssessmentAcceleratorIntro &&
                this.shouldShowIntro);
        },
        themeName() {
            var _a;
            return (_a = this.theme) === null || _a === void 0 ? void 0 : _a.name;
        },
        getCurriculumName() {
            var _a, _b, _c, _d, _e;
            const productCurriculumId = (_b = (_a = this.licenses) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.productCurriculumId;
            const activityProductCurriculum = (_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.productCurriculums) === null || _d === void 0 ? void 0 : _d.find(p => p.id === productCurriculumId);
            return (_e = activityProductCurriculum === null || activityProductCurriculum === void 0 ? void 0 : activityProductCurriculum.name) !== null && _e !== void 0 ? _e : productCurriculumIdMap[productCurriculumId !== null && productCurriculumId !== void 0 ? productCurriculumId : 2];
        },
        getAppTitle(titleDescription) {
            var _a;
            const isCurriculumIntro = window.location.pathname.endsWith('/curriculum');
            const isCompletionPage = window.location.pathname.endsWith('/activity-trophy');
            const isTeacherCreation = window.location.pathname.endsWith('/TeacherCreation');
            const isPreviewOrTester = !!this.kwtMode && ['preview', 'previewLite', 'tester'].includes(this.kwtMode);
            const curriculumName = this.getCurriculumName();
            const isProgressModal = ((_a = this.modal) === null || _a === void 0 ? void 0 : _a.type) === 'progress';
            const isSpeedyKid = this.themeName() === 'Speedy Keyboard Kid';
            const isKeyboardIntro = this.isKeyboardCheckActivity() && this.shouldShowIntro;
            const isSpotCheckIntro = this.isSpotCheck && this.shouldShowIntro;
            if (titleDescription)
                return `${curriculumName} - ${titleDescription} - Keyboarding Without Tears`;
            const getDescriptionText = () => {
                var _a;
                switch (true) {
                    case isTeacherCreation && this.isEndOfActivity: {
                        return 'Enrichment Activity Completion Page';
                    }
                    case isTeacherCreation: {
                        return `Enrichment Activity - ${this.getActivityTitle(true)}`;
                    }
                    case isKeyboardIntro: {
                        return `Keyboard Check - ${this.getActivityTitle()}`;
                    }
                    case isSpotCheckIntro: {
                        return `${this.weekText()} - ${this.activityAsnText()} - Spot Check Introduction Page - ${(_a = this.activityTitle) === null || _a === void 0 ? void 0 : _a.display}`;
                    }
                    case this.isAAIntro(): {
                        return `${this.formatAADescription()} - ${this.translateCategory()} ${this.getActivityTitle()}`;
                    }
                    case this.isAssessmentAcceleratorActivity(): {
                        return `${this.formatAADescription()} - ${this.getActivityTitle()} - ${this.translateCategory()}`;
                    }
                    case isProgressModal: {
                        return `Rewards Page`;
                    }
                    case isCurriculumIntro && isSpeedyKid: {
                        return `${this.themeName()} Introduction Page`;
                    }
                    case isCurriculumIntro: {
                        return `${this.weekText()} - Weekly Theme Progress Page - ${this.themeName()}`;
                    }
                    case isCompletionPage: {
                        return `${this.weekText()} - ${this.activityAsnText()} - Activity Completion Page`;
                    }
                    default: {
                        return `${this.weekText()} - ${this.activityAsnText()} - ${this.getActivityTitle()}`;
                    }
                }
            };
            return isPreviewOrTester
                ? `${this.getActivityTitle()} - Keyboarding Without Tears`
                : `${curriculumName} - ${getDescriptionText()} - Keyboarding Without Tears`;
        } }),
    mounted() {
        this.setAppTitle();
        this.$watch(
        //@ts-ignore
        () => [
            this.showIntro,
            this.viewedIntro,
            this.shouldShowIntro,
            this.curriculumPosition,
            this.data,
            this.modal,
            this.isEndOfActivity
        ], () => this.setAppTitle(''), {
            immediate: true
        });
    }
});
